import ChoiceBoardsView from "@features/tools/view/choice-boards-view";

const ChoiceBoards = () => {
  return <ChoiceBoardsView />;
};

export default ChoiceBoards;
